import { Api } from "../api.service";
import { ApiTranslate } from "@/utils/decorators";
import { SecretHash } from "~/secret_hash";

/**
 * @description Class describes business logic
 * for changing user email, confirmation and etc
 */
export class EmailService {
  @ApiTranslate
  public static async changeEmail(email: string): Promise<MessageValue> {
    await Api.put("/auth/email", {
      email,
    });
    return {
      result: true,
    };
  }
  @ApiTranslate
  public static async restorePassword(
    email: string,
    recaptchaToken: string,
  ): Promise<MessageValue> {
    await Api.get(`/auth/restorePassword/${email}`, {
      params: { recaptchaToken },
    });
    return {
      result: true,
    };
  }

  public static async isSercretHashExists(
    secretHash: string,
  ): Promise<SecretHash> {
    const res = await Api.post("/auth/isSercretHashExists", {
      secretHash,
    });
    return res.data;
  }

  public static async updatePassword(secretHash: string, password: string) {
    const res = await Api.post("/auth/updatePassword", {
      secretHash,
      password,
    });
    return res.data;
  }

  @ApiTranslate
  public static async verifyUserEmail(secretHash: string): Promise<any> {
    const response = await Api.put("/auth/emailconfirm", {
      secretHash,
    });
    return {
      result: response.data,
    };
  }
}
